import { type App } from 'vue';
import pageTop from './page-top';

export const registerDirectives = (app: App): void => {
  app.directive('page-top', pageTop);
};
